import { render } from "../../views/chat/feedback_modal.html?vue&type=template&id=5bd857d0&ts=true&external"
import script from "../../scripts/chat/feedback_modal.ts?vue&type=script&lang=ts&external"
export * from "../../scripts/chat/feedback_modal.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/chat/feedback_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bd857d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bd857d0', __exports__)) {
    api.reload('5bd857d0', __exports__)
  }
  
  module.hot.accept("../../views/chat/feedback_modal.html?vue&type=template&id=5bd857d0&ts=true&external", () => {
    api.rerender('5bd857d0', render)
  })

}


export default __exports__